/**
 * Default PDF Viewer sample
 */
import * as ReactDOM from "react-dom";
import * as React from "react";
//import "./pdf.component.css";
import { useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  Group,
  Menu,
  Select,
  rem,
  Text,
  Box,
  NumberInput,
  TextInput,
  ScrollArea,
  Stepper,
  Title,
  ThemeIcon,
  Divider,
  SegmentedControl,
  Input,
  Blockquote,
  ActionIcon,
  Drawer,
  List,
  Tabs,
  ComboboxItem,
  Checkbox,
  LoadingOverlay,
  Flex,
  Badge,
  Indicator,
  Accordion,
  Center,
  Tooltip,
  Avatar,
} from "@mantine/core";
import {
  IconAccessPoint,
  IconAdjustments,
  IconArrowLeft,
  IconArrowRight,
  IconAtom,
  IconCaretLeftFilled,
  IconCaretRight,
  IconCaretRightFilled,
  IconCircleCheck,
  IconDots,
  IconFocus2,
  IconGripVertical,
  IconKeyboard,
  IconLocation,
  IconPencil,
  IconPlayerTrackNextFilled,
  IconPlayerTrackPrevFilled,
  IconPlus,
  IconSearch,
  IconSend,
  IconSignature,
  IconSignRight,
  IconTrash,
  IconUserBolt,
  IconWritingSign,
} from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import "./pdf.component.css";

import { IconUpload, IconPhoto, IconX } from "@tabler/icons-react";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { TestModel } from "../../stories/TestModel";
import { useStepSignStore } from "../../store";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import cx from "clsx";
import {
  randomId,
  useDisclosure,
  useHotkeys,
  useListState,
} from "@mantine/hooks";
import classes from "./DndListHandle.module.css";
import { hasLength, isEmail, useForm } from "@mantine/form";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { Delay, DelayTime } from "../../_base/helper/FunctionHelper";

import {
  LocalizationMap,
  Viewer,
  Worker,
  SpecialZoomLevel,
  RenderPage,
  RenderPageProps,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { ClassAttributes, HTMLAttributes } from "react";
import { Code, JsonInput } from "@mantine/core";
import { useMove } from "@mantine/hooks";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "./Main.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import {
  pageNavigationPlugin,
  RenderCurrentPageLabelProps,
  RenderGoToPageProps,
} from "@react-pdf-viewer/page-navigation";
import { Rnd } from "react-rnd";

import Signature from "@uiw/react-signature";
import { getFilePlugin, RenderDownloadProps } from "@react-pdf-viewer/get-file";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import { TransformToolbarSlot } from "@react-pdf-viewer/toolbar";
import { useNavigate, useParams } from "react-router-dom";
import {
  convertSignType,
  fetchDataDepartment,
  fetchDataDocType,
  getFormattedDateUTCPlus7,
  repositorySign,
  signTypes,
  signTypesModel,
  workerUrl,
} from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { DocumentModel } from "../../model/DocumentModel";
import { TblDocument } from "../../model/TblDocument";
import {
  findDocumentBySignatureId,
  listColor,
  ListStepSign,
  SignaturePage,
} from "../../model/SignPage";
import { AddLocationSignModel } from "../../model/AddLocationSignModel";
import { isValidEmail } from "../../_base/extension/Extension";
import { getRoleSelect, getUsersSelect } from "../../const/getSelectApi";
import { get } from "http";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { TblSampleProcess } from "../../model/TblSampleProcess";
import { join } from "path";

type State = {
  x: number;
  y: number;
  width: number;
  height: number;
};
interface PageItem {
  label: string;
  value: string;
  checked: boolean;
  key: number;
}
interface ListValue {
  label: string;
  value: string;
  typecustomer: number;
}
function FlowStepExampleV2() {
  // let viewer: PdfViewerComponent | null;
  const [active, setActive] = useState(0);
  const [handlerSelectType, setHandlerSelectType] = useState<Array<ListValue>>(
    []
  );
  let params = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState<TblDocument>();

  const _init: ListStepSign[] = [];
  const [fromValuesTemp, setFromValuesTemp] = useState(_init);

  const formValues = useForm({
    mode: "uncontrolled",
    validateInputOnChange: false,
    initialValues: {
      listStepSign: _init,
    },
    validate: {
      listStepSign: {
        name: (value) => (value.length < 2 ? "Tên bước chưa nhập" : null),
        email: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (handlerSelectType[index]?.label === "2" && !value) {
            return "Chưa nhập email";
          }
          if (handlerSelectType[index]?.label === "2" && !isValidEmail(value)) {
            return "Email không hợp lệ";
          }
          return null;
        },
        phone: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (handlerSelectType[index]?.label === "3" && !value) {
            return "Chưa nhập số điện thoại !";
          }
          return null;
        },
        username: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (
            handlerSelectType[index]?.label === "0" &&
            (!value || value.length < 1)
          ) {
            return "Chưa chọn người xử lý";
          }
          return null;
        },
        typesigncustomer: (value, values, path) => {
          console.log(value);
          if (!value) return "Chưa chọn công cụ ký !";
          const _val = Number(value);
          if (_val < 0) {
            return "Chưa chọn công cụ ký !";
          }
          return null;
        },

        typesign: (value, values, path) => {
          if (!value || value.length < 1) return "Chưa chọn loại hình ký !";
          return null;
        },
      },
    },
  });
  const _span = { base: 12, lg: 12, xl: 6 };
  const _spanTitle = { base: 6, lg: 4, xl: 4 };
  const entity: TblSampleProcess = {
    id: 0,
    name: "",
    doctypeId: 0,
    signedDocument: "",
    stepupsignjson: "",
    totalstep: 0,
  };
  const form = useForm<TblSampleProcess>({
    mode: "controlled",
    validateInputOnChange: false,
    initialValues: entity,
    validate: {
      name: (value) => {
        if (!value) {
          return "Vui lòng nhập tên quy trình phê duyệt !";
        }
        return hasLength(
          { min: 5, max: 150 },
          "Tên phải từ 5-150 kí tự!"
        )(value as string);
      },

      doctypeId: (value) => {
        if (!value) {
          return "Vui lòng chọn loại hồ sơ !";
        }
      },
    },
  });
  const [listDocType, setListDocType] = useState<SelectListItem[]>([]);
  const [listDeparrt, setListDepart] = useState<SelectListItem[]>([]);
  const [dataListRole, setDataListRole] = useState<SelectListItem[]>([]);
  const [selectedDepartments, setSelectedDepartments] = useState<string>("");
  const [searchDepartment, setSearchDepartment] = useState<string>("");

  const fetchDataRole = async () => {
    const dataApi = await getRoleSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListRole(filteredData);
    }
  };
  useEffect(() => {
    fetchDataDocType().then((data) => {
      if (data) setListDocType(data);
    });
    fetchDataDepartment().then((data) => {
      if (data) {
        setListDepart(data);
        handlersCheckbox.setState(data);
      }
    });
    fetchDataEmployee();
    fetchDataRole();
  }, []);

  function Controls() {
    return (
      <Grid mb={"xs"}>
        <Grid.Col span={_spanTitle}>
          <TextInput
            label="Tên quy trình phê duyệt:"
            key={form.key("name")}
            withAsterisk
            value={""}
            placeholder="Nhập"
            {...form.getInputProps("name")}
          />
        </Grid.Col>
        <Grid.Col span={_spanTitle}>
          <Select
            key={form.key("doctypeId")}
            label="Loại hồ sơ:"
            placeholder="Vui lòng chọn hồ sơ"
            nothingFoundMessage="Không có dữ liệu"
            data={listDocType.map((doctype) => ({
              value: doctype.value,
              label: doctype.text,
            }))}
            searchable
            withAsterisk
            // onClick={async () => {
            //   if (listDocType.length === 0) {
            //     const data = await fetchDataDocType();
            //     if (data) setListDocType(data);
            //   }
            // }}
            {...form.getInputProps("doctypeId")}
          />
        </Grid.Col>
        <Grid.Col span={_spanTitle}>
          <Menu
            shadow="md"
            // onOpen={() => {
            //   const _sort = listDeparrt.sort((x) => (x.selected ? 1 : -1));
            //   handlersCheckbox.setState(_sort);
            // }}
            closeOnItemClick={false}
          >
            <Menu.Target>
              {/* <Button w={"100%"}>Chọn trang ký</Button> */}
              <TextInput
                label="Đơn vị áp dụng:"
                placeholder="Tìm kiếm..."
                value={selectedDepartments}
                readOnly
                rightSection={
                  <IconCaretRightFilled
                    size={16}
                    style={{ transform: "rotate(90deg)" }}
                  />
                }
              />
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Danh sách đơn vị</Menu.Label>
              <TextInput
                placeholder="Tìm kiếm đơn vị..."
                value={searchDepartment}
                onChange={(event) =>
                  setSearchDepartment(event.currentTarget.value)
                }
                leftSection={<IconSearch size={16} />}
                mb="xs"
              />
              <Divider />
              <ScrollArea mt={"xs"} h={350}>
                {itemCheckboxs}
              </ScrollArea>
            </Menu.Dropdown>
          </Menu>
        </Grid.Col>
      </Grid>
    );
  }
  // useEffect(() => {
  //   console.log(formValues.getValues().listStepSign);
  // }, [formValues]);
  const [state, handlers] = useListState<TestModel>([]);
  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item) => item.text !== null);
      setDataListUser(filteredData);
    }
  };

  const updatePageBySignatureKey = (
    stepKey: string,
    signatureKey: string,
    newPage: number
  ) => {
    setData((prevListStepSign) =>
      prevListStepSign.map((step) => {
        if (step.key === stepKey) {
          return {
            ...step,
            list: step.list.map((signature) =>
              signature.key === signatureKey
                ? { ...signature, page: newPage }
                : signature
            ),
          };
        }
        return step;
      })
    );
  };
  function resetHalderSelectType() {
    const _data = formValues.getValues().listStepSign.map((item) => {
      return {
        value: item.key,
        label: item.typesign,
        typecustomer: item.typesigncustomer,
      } as ListValue; // Chuyển kiểu dữ liệu về ListValue
    });
    setHandlerSelectType(_data);
  }
  const items = formValues.getValues().listStepSign.map((item, index) => (
    <Draggable key={item.key} index={index} draggableId={item.key}>
      {(provided, snapshot) => (
        <div
          className={cx(classes.item, {
            [classes.itemDragging]: snapshot.isDragging,
          })}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <Accordion.Item value={item.key} key={item.key}>
            <Center>
              <Accordion.Control>
                <Flex>
                  <Title order={5}>
                    Bước {index + 1}: {item.name}
                  </Title>
                </Flex>
              </Accordion.Control>

              {/* {handlerSelectType[index]?.typecustomer > 0 && (
                <>
                  {" "}
                  <Tooltip label="Thêm vị trí">
                    <ActionIcon
                      onClick={() => {
                        //  if (selectType === "Ký ảnh")
                        handleAddStep(
                          item.key,
                          handlerSelectType[index]?.typecustomer,
                          pageCurrent
                        );
                        //  setSelectType("Ký ảnh");
                      }}
                      size="lg"
                      variant="default"
                      color="gray"
                    >
                      <IconFocus2 color="green" />
                    </ActionIcon>
                  </Tooltip>
                </>
              )} */}

              <Tooltip label="Thêm bước">
                <ActionIcon
                  onClick={AddStep}
                  ml={"xs"}
                  size="lg"
                  variant="default"
                  color="gray"
                >
                  <IconPlus color="blue" />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Xóa bước">
                <ActionIcon
                  onClick={() => {
                    const _index = formValues
                      .getValues()
                      .listStepSign.findIndex((x) => x.key === item.key);
                    //  if (_index >= 0) handlers.remove(_index);
                    if (_index >= 0) {
                      formValues.removeListItem("listStepSign", _index);
                      // setHandlerSelectType(
                      //   handlerSelectType.filter((x) => x.value !== item.key)
                      // );
                      resetHalderSelectType();
                    } else
                      NotificationExtension.Fails(
                        "Không tìm thấy bước để xóa !"
                      );
                  }}
                  ml={"xs"}
                  size="lg"
                  variant="default"
                  color="gray"
                >
                  <IconTrash color="red" />
                </ActionIcon>
              </Tooltip>
              <div {...provided.dragHandleProps} className={classes.dragHandle}>
                <Tooltip label="Di chuyển">
                  <ActionIcon
                    ml={"xs"}
                    size="lg"
                    variant="default"
                    color="gray"
                  >
                    <IconGripVertical
                      style={{ width: rem(28), height: rem(28) }}
                      color="black"
                    />
                  </ActionIcon>
                </Tooltip>
              </div>
            </Center>

            <Accordion.Panel>
              <form
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "end",
                }}
                // onSubmit={(e) => {console.log(e)}}
              >
                <Grid>
                  <Grid.Col span={_span}>
                    {" "}
                    <TextInput
                      withAsterisk
                      label="Tên bước"
                      placeholder="Nhập..."
                      key={formValues.key(`listStepSign.${index}.name`)}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.name`
                      )}
                    />
                  </Grid.Col>

                  <Grid.Col span={_span}>
                    {" "}
                    <Select
                      label="Loại hình ký: "
                      withAsterisk
                      placeholder="Nhập..."
                      nothingFoundMessage="Không có dữ liệu"
                      data={signTypesModel.map((x) => ({
                        label: x.label,
                        value: x.value.toString(), // Chuyển đổi value sang string
                      }))}
                      searchable
                      clearable
                      {...formValues.getInputProps(
                        `listStepSign.${index}.typesign`
                      )}
                      key={formValues.key(`listStepSign.${index}.typesign`)}
                      onChange={(e) => {
                        // console.log(formValues.getValues().listStepSign);
                        // setFromValuesTemp(formValues.getValues().listStepSign);
                        // const _sign = e?.toString() ?? "0";
                        // let updatedHandlerSelectType = [...handlerSelectType]; // Tạo một bản sao của handlerSelectType
                        // const element =
                        //   formValues.getValues().listStepSign[index];
                        // const elementIndex = updatedHandlerSelectType.find(
                        //   (x) => x.value === element.key
                        // );

                        // if (elementIndex && elementIndex.value.length > 0) {
                        //   // Đã có trong mảng `handlerSelectType`
                        //   if (elementIndex.label !== _sign) {
                        //     updatedHandlerSelectType[index] = {
                        //       ...updatedHandlerSelectType[index],
                        //       label: _sign,
                        //     };
                        //     setHandlerSelectType(updatedHandlerSelectType);
                        //   }
                        // }
                        formValues.setFieldValue(
                          `listStepSign.${index}.typesign`,
                          e
                        );
                        const _sign = e?.toString() ?? "0";
                        let updatedHandlerSelectTypeUpdate =
                          handlerSelectType[index];

                        if (updatedHandlerSelectTypeUpdate) {
                          // Đã có trong mảng `handlerSelectType`
                          if (updatedHandlerSelectTypeUpdate.label !== _sign) {
                            updatedHandlerSelectTypeUpdate.label = _sign;
                            setHandlerSelectType([
                              ...handlerSelectType,
                              updatedHandlerSelectTypeUpdate,
                            ]);
                          }
                        }
                      }}
                    />
                  </Grid.Col>
                  {(handlerSelectType[index]?.label === "0" ||
                    !handlerSelectType[index]) && (
                    <Grid.Col span={_span}>
                      <Select
                        key={formValues.key(`listStepSign.${index}.username`)}
                        label="Người xử lý"
                        withAsterisk
                        placeholder="Chọn..."
                        clearable
                        searchable
                        limit={50}
                        comboboxProps={{
                          transitionProps: {
                            transition: "pop",
                            duration: 200,
                          },
                        }}
                        data={dataListUser.map((item) => {
                          return {
                            label: item.text,
                            value: item.value,
                          };
                        })}
                        nothingFoundMessage="Dữ liệu không có !"
                        {...formValues.getInputProps(
                          `listStepSign.${index}.username`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {handlerSelectType[index]?.label === "1" && (
                    <Grid.Col span={_span}>
                      <Select
                        withAsterisk
                        label="Chức danh"
                        placeholder="Nhập..."
                        key={formValues.key(`listStepSign.${index}.roleid`)}
                        searchable
                        clearable
                        limit={50}
                        comboboxProps={{
                          transitionProps: {
                            transition: "pop",
                            duration: 200,
                          },
                        }}
                        data={dataListRole.map((item) => {
                          return {
                            label: item.text,
                            value: String(item.value ?? ""),
                          };
                        })}
                        nothingFoundMessage="Dữ liệu không có !"
                        {...formValues.getInputProps(
                          `listStepSign.${index}.roleid`
                        )}
                      />
                    </Grid.Col>
                  )}

                  {Number.parseInt(handlerSelectType[index]?.label ?? "0") >
                    1 && (
                    <Grid.Col span={_span}>
                      <Select
                        label="Đối tác"
                        placeholder="Nhập..."
                        key={formValues.key(`listStepSign.${index}.vendorid`)}
                        searchable
                        clearable
                        {...formValues.getInputProps(
                          `listStepSign.${index}.vendorid`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {(handlerSelectType[index]?.label ?? "0") === "2" && (
                    <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Email"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.email`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.email`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {(handlerSelectType[index]?.label ?? "0") === "3" && (
                    <Grid.Col span={_span}>
                      <TextInput
                        withAsterisk
                        label="Số điện thoại"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.phone`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.phone`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {Number.parseInt(handlerSelectType[index]?.label ?? "0") >
                    1 && (
                    <>
                      {/* <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Ekyc"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.issign`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.issign`,
                          {
                            type: "checkbox",
                          }
                        )}
                      />
                    </Grid.Col>
                    <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Thêm bước"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.addstep`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.addstep`,
                          {
                            type: "checkbox",
                          }
                        )}
                      />
                    </Grid.Col> */}
                      <Grid.Col span={_span}>
                        {" "}
                        <TextInput
                          label="Mã số thuế"
                          placeholder="Nhập"
                          key={formValues.key(`listStepSign.${index}.taxcode`)}
                          {...formValues.getInputProps(
                            `listStepSign.${index}.taxcode`
                          )}
                        />
                      </Grid.Col>
                    </>
                  )}

                  <Grid.Col span={_span}>
                    <Select
                      key={formValues.key(
                        `listStepSign.${index}.typesigncustomer`
                      )}
                      withAsterisk
                      label="Công cụ ký: "
                      placeholder="Nhập..."
                      nothingFoundMessage="Không có dữ liệu"
                      //  defaultValue={signTypes[0].value.toString()}
                      data={signTypes.map((x) => ({
                        label: x.label,
                        value: x.value.toString(), // Chuyển đổi value sang string
                      }))}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.typesigncustomer`
                      )}
                      onChange={(e) => {
                        formValues.setFieldValue(
                          `listStepSign.${index}.typesigncustomer`,
                          e
                        );

                        // console.log(formValues.getValues().listStepSign);
                        // setFromValuesTemp(formValues.getValues().listStepSign);
                        const _sign = e?.toString() ?? "0";
                        let updatedHandlerSelectTypeUpdate =
                          handlerSelectType[index];

                        if (updatedHandlerSelectTypeUpdate) {
                          // Đã có trong mảng `handlerSelectType`
                          if (
                            updatedHandlerSelectTypeUpdate.typecustomer !==
                            Number.parseInt(_sign)
                          ) {
                            updatedHandlerSelectTypeUpdate.typecustomer =
                              Number.parseInt(_sign);
                            setHandlerSelectType([
                              ...handlerSelectType,
                              updatedHandlerSelectTypeUpdate,
                            ]);
                          }
                        }
                      }}
                    />
                  </Grid.Col>
                  <Grid.Col span={_span}>
                    {" "}
                    <NumberInput
                      key={formValues.key(`listStepSign.${index}.expdate`)}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.expdate`
                      )}
                      min={0}
                      label="Quá hạn sau(ngày)"
                      placeholder="Nhập"
                    />
                  </Grid.Col>
                </Grid>
              </form>

              <Divider size={"md"} my="lg" variant="dashed" />

              <Group>
                {data
                  .find((xx) => xx.key === item.key)
                  ?.list.map((sign, index) => (
                    <>
                      <Group>
                        <Text>{index + 1}. Chọn trang</Text>
                        <NumberInput
                          size="xs"
                          style={{ width: "55px" }}
                          value={sign.page + 1}
                          onClick={() => {
                            setSelectedItemId(sign.key);
                          }}
                          hideControls
                          onKeyUp={(e) => {
                            const _v = e.currentTarget.value;
                            if (e.key === "Enter") {
                              // Kiểm tra nếu phím Enter được nhấn
                              const value =
                                typeof _v === "string"
                                  ? Number.parseInt(_v)
                                  : (e.target as HTMLInputElement)
                                      .valueAsNumber;
                              const h = value > 0 ? value - 1 : 0;

                              if (typeof h === "number") {
                                if (h < 0) {
                                  NotificationExtension.Fails(
                                    "Số trang phải lớn hơn 0 !"
                                  );
                                  return;
                                }
                                if (h > pageTotal) {
                                  NotificationExtension.Fails(
                                    "Số trang phải nhỏ hơn hơn " +
                                      pageTotal +
                                      " !"
                                  );
                                  return;
                                }
                                updatePageBySignatureKey(item.key, sign.key, h);
                              }

                              jumpToPage(h);
                              //  setDisabledBtn(true);
                              setPageCurrent(h);
                            }
                          }}
                          // onChange={(e) => {
                          //   if (typeof e === "number") {
                          //     if (e < 1) {
                          //       NotificationExtension.Fails(
                          //         "Số trang phải lớn hơn 0 !"
                          //       );
                          //       return;
                          //     }
                          //     if (e > pageTotal) {
                          //       NotificationExtension.Fails(
                          //         "Số trang phải nhỏ hơn hơn " +
                          //           pageTotal +
                          //           " !"
                          //       );
                          //       return;
                          //     }
                          //     updatePageBySignatureKey(
                          //       item.key,
                          //       sign.key,
                          //       e - 1
                          //     );
                          //   }
                          // }}
                        />

                        <ActionIcon
                          size="md"
                          variant="outline"
                          color="red"
                          aria-label="ActionIcon the same size as inputs"
                          onClick={() => {
                            const filteredData = data.map((document) => ({
                              ...document,
                              list: document.list.filter(
                                (signature) => signature.key !== sign.key
                              ),
                            }));
                            setData(filteredData);
                          }}
                        >
                          <IconTrash />
                        </ActionIcon>
                        <Divider size="md" orientation="vertical" />
                      </Group>
                    </>
                  ))}
              </Group>
            </Accordion.Panel>
          </Accordion.Item>
        </div>
      )}
    </Draggable>
  ));

  //
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [userSelect, setUserSelect] = useState<boolean>(false);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (230 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  //new sign
  // luc chot thi map lại vào form value
  const [data, setData] = useState<Array<ListStepSign>>([]);

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  // const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;
  useEffect(() => {
    console.log("data:", data);
  }, [data]);
  //
  const renderPage: RenderPage = (props: RenderPageProps) => {
    return (
      <>
        {props.canvasLayer.children}
        {props.annotationLayer.children}
        {props.textLayer.children}
        {/* type là duyệt thì không cần hiển thị */}
        {data
          .filter((x) => x.typesigncustomer !== 0)
          .map((doc, index) =>
            doc.list
              .filter((signaturePage) => {
                // console.log("File comparison:", signaturePage.files, urlFile);
                // console.log("check:", signaturePage.files === urlFile);
                return (
                  signaturePage.page === props.pageIndex &&
                  signaturePage.files?.toString() === urlFile
                );
              })
              .map((item, indexSign) => (
                <Rnd
                  key={item.key}
                  className="signature-step"
                  bounds={boundaryElm}
                  size={{
                    width: item.width,
                    height: item.height,
                  }}
                  position={{
                    x: item.x,
                    y: item.y,
                  }}
                  onDragStop={(e: any, d: any) => {
                    const updatedKy: SignaturePage[] = doc.list.map(
                      (kyPage, kyIndex) => {
                        //  if (kyPage.page === pageCurrent) {
                        if (true) {
                          return {
                            ...kyPage,
                            ...(kyPage.key === item.key && {
                              x:
                                d.x + kyPage.width > props.width
                                  ? props.width - kyPage.width
                                  : d.x < 0
                                  ? 0
                                  : d.x,
                              y:
                                d.y + kyPage.height > props.height
                                  ? props.height - kyPage.height
                                  : d.y < 0
                                  ? 0
                                  : d.y,
                            }),
                          };
                        }
                        return kyPage;
                      }
                    );
                    const _res = data.map((d) =>
                      d.key === doc.key ? { ...d, list: updatedKy } : d
                    );
                    setData(_res);

                    // setData(
                    //   data.map((d) =>
                    //     d.key === doc.key ? { ...d, list: updatedKy } : d
                    //   )
                    // );
                  }}
                  onResize={(e, direction, ref, delta, position) => {
                    const updatedKy: SignaturePage[] = doc.list.map(
                      (kyPage, kyIndex) =>
                        //   kyPage.page === pageIndex + 1
                        true
                          ? {
                              ...kyPage,
                              ...(kyPage.key === item.key && {
                                with: ref.offsetWidth,
                                height: ref.offsetHeight,
                                ...position,
                              }),
                            }
                          : kyPage
                    );
                    const _res = data.map((d) =>
                      d.key === doc.key ? { ...d, list: updatedKy } : d
                    );
                    setData(_res);
                    // setData(
                    //   data.map((d) =>
                    //     d.key === doc.key ? { ...d, list: updatedKy } : d
                    //   )
                    // );
                  }}
                  onClick={() => {
                    //  console.log(props.height,props.width)
                    if (item.key !== selectedItemId) {
                      setSelectedItemId(item.key);
                      var check = findDocumentBySignatureId(
                        data,
                        selectedItemId
                      );
                      if (check && check.page !== pageCurrent) {
                        setPageCurrent(check.page);
                      }

                      const getSignPage = data.find(
                        (x) =>
                          x.list.findIndex((xx) => xx.key === item.key) !== -1
                      );
                      if (getSignPage) {
                        setSelectedLibrary(getSignPage.key);
                      }

                      const getTypeSelect = convertSignType(
                        getSignPage?.typesigncustomer || -1
                      );
                      setSelectType(getTypeSelect);
                    }
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "10px",
                    justifyContent: "center",
                    border:
                      selectedItemId === item.key
                        ? "solid 3.5px #228be6"
                        : "solid 1px #228be6",
                    background: "transparent",

                    color: "#228be6",
                    fontWeight: "bold",
                    fontSize: "12px",
                    zIndex: 9999,
                  }}
                >
                  <ActionIcon
                    onClick={() => {
                      const filteredData = data.map((document) => ({
                        ...document,
                        list: document.list.filter(
                          (signature) => signature.key !== item.key
                        ),
                      }));
                      setData(filteredData);
                    }}
                    size={"xs"}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                    }}
                    variant="filled"
                    color="red"
                    aria-label="Settings"
                  >
                    <IconX stroke={1.5} />
                  </ActionIcon>{" "}
                  <ActionIcon
                    size={"xs"}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: `${item.width - 12}` + "px",
                    }}
                    variant="filled"
                    //  / color="red"
                    aria-label="Settings"
                  >
                    <Indicator
                      inline
                      label={indexSign + 1}
                      size={16}
                    ></Indicator>
                  </ActionIcon>
                  {/* lay theo tung vi tri, fix tam khong lay theo buoc ky==> parseInt(item?.typesigncustomer?.toString() */}
                  {`Bước ${doc.numberstep}: ${convertSignType(
                    doc.typesigncustomer
                  )}  `}
                </Rnd>
              ))
          )}
      </>
    );
  };
  const [pageCurrent, setPageCurrent] = useState<number>(-1);
  const [pageTotal, setPageTotal] = useState<number>(1);

  const [stateSign, setStateSign] = useState<State>({
    width: 120,
    height: 70,
    x: 0,
    y: 0,
  });
  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  //
  const [selectedLibrary, setSelectedLibrary] = useState<string | null>(); // Quản lý giá trị Select
  const [selectType, setSelectType] = useState<string>("");
  const [selectFile, setSelectFile] = useState<string>();

  function AddStep() {
    const newDocument: ListStepSign = {
      id: 0,
      key: randomId(),
      username: "",
      email: "",
      numberstep: formValues.getValues().listStepSign?.length + 1,
      list: [],
      idsetupstepsign: 0,
      name: "",
      typesign: "0",
      typesigncustomer: 0,
      issign: 0,
      filehistorysign: "",
      vendorid: 0,
    };
    formValues.insertListItem("listStepSign", newDocument, 0);
    let updatedHandlerSelectType = [...handlerSelectType]; // Tạo một bản sao của handlerSelectType
    setHandlerSelectType([
      ...handlerSelectType,
      {
        label: newDocument.typesign,
        value: newDocument.key,
        typecustomer: newDocument.typesigncustomer,
      },
    ]);
  }

  useHotkeys([
    [
      "ctrl+d",
      () => {
        AddStep();
      },
    ],
  ]);

  const handleAddStep = (
    userNameSelect: string,
    type: number,
    pageNumber: number,
    x: number = stateSign.x,
    y: number = stateSign.y,
    w: number = stateSign.width,
    h: number = stateSign.height
  ) => {
    if (
      !urlFile ||
      urlFile.length < 6 ||
      !document?.signedDocument.split("||").find((x) => x.includes(urlFile)) ||
      selectFile === undefined
    ) {
      NotificationExtension.Fails("Không tìm thấy file !");
      return;
    }
    // pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    const getUserSelect = formValues
      .getValues()
      .listStepSign.find((item) => item.key === userNameSelect);
    if (getUserSelect) {
      const _sign: SignaturePage = {
        key: randomId(),
        x: x,
        y: y,
        width: w,
        height: h,
        page: pageNumber,
        id: 0,
        files: urlFile,
        namefilefrist: selectFile ?? "",
        typesigncustomer: type,
      };
      const existingDocumentIndex = data.findIndex(
        (doc) => doc.key === userNameSelect
      );
      //note: type >0 thì mới tạo vị trí để ký
      // kiểu duyệt không cần update hay thêm gì cả
      if (existingDocumentIndex !== -1) {
        // Nếu đã tồn tại userNameSelect
        const updatedDocuments = data.map((doc, index) => {
          if (index === existingDocumentIndex) {
            const pageIndex = doc.list.findIndex(
              (page) => page.page === pageNumber
            ); // Kiểm tra page 1 đã tồn tại

            if (pageIndex !== -1) {
              console.log("Page found: ", pageNumber);
              let update: Array<SignaturePage> = doc.list;
              if (type > 0)
                doc.list.forEach((signaturePage, idx) => {
                  if (idx === pageIndex) {
                    update.push(_sign);
                    return;
                  }
                });
              const _res: ListStepSign = {
                ...doc,
                // cho update hết về 1 type
                typesigncustomer: type,
                list: type === 0 ? doc.list : update,
              };
              return _res;
            } else {
              console.log("Page not found: ", pageNumber);
              const _updated: SignaturePage = {
                page: pageNumber,
                id: _sign.id,
                x: _sign.x,
                y: _sign.y,
                width: _sign.width,
                height: _sign.height,
                key: _sign.key,
                files: _sign.files,
                namefilefrist: _sign.namefilefrist,
              };
              const _res: ListStepSign = {
                ...doc,

                typesigncustomer: type,
                list: type === 0 ? doc.list : [...doc.list, _updated],
              };

              return _res;
            }
          }
          return doc;
        });
        console.log("Update new document: ", updatedDocuments);
        setData(updatedDocuments);
      } else {
        // Nếu chưa tồn tại selectedLibrary, tạo Document mới
        const newDocument: ListStepSign = {
          id: 0,
          key: getUserSelect.key,
          username: getUserSelect.username,
          email: getUserSelect.email ? getUserSelect.email.toLowerCase() : "",
          numberstep: getUserSelect.numberstep,
          list: type === 0 ? [] : [_sign],
          idsetupstepsign: 0,
          name: getUserSelect.name,
          typesign: getUserSelect.typesign,
          typesigncustomer: type,
          issign: 0,
          filehistorysign: "",
          vendorid: 0,
        };
        console.log("Add new document: ", newDocument);
        setData([...data, newDocument]);
      }
    } else {
      NotificationExtension.Info("Bạn chưa chọn người ký !");
      setSelectType("");
    }
  };
  const [values, handlersCheckbox] = useListState(listDeparrt);

  const allChecked = values.every((value) => value.selected);
  const indeterminate = values.some((value) => value.selected) && !allChecked;
  const itemCheckboxs = [...values]
    .sort((a, b) => Number(b.selected) - Number(a.selected))
    .filter(
      (valueCheckbox) =>
        searchDepartment === "" ||
        valueCheckbox.text
          .toLowerCase()
          .includes(searchDepartment.toLowerCase())
    )
    .map((valueCheckbox, index) => (
      <Checkbox
        mt="xs"
        // ml={33}
        label={valueCheckbox.text}
        key={valueCheckbox.value}
        checked={valueCheckbox.selected}
        onChange={async (event) => {
          var _index = values.findIndex((x) => x.value == valueCheckbox.value);
          if (event.target.checked) {
            handlersCheckbox.setItemProp(_index, "selected", true);
          } else handlersCheckbox.setItemProp(_index, "selected", false);
        }}
      />
    ));

  useEffect(() => {
    console.log(values.filter((x) => x.selected));
    const _data = values.sort(function (x, y) {
      return x === y ? 0 : x ? -1 : 1;
    });
    handlersCheckbox.setState(_data);

    // Cập nhật text hiển thị các đơn vị đã chọn
    const selectedItems = values.filter((x) => x.selected);
    if (selectedItems.length === 0) {
      setSelectedDepartments("");
    } else if (selectedItems.length === 1) {
      setSelectedDepartments(selectedItems[0].text);
    } else {
      setSelectedDepartments(`Đã chọn ${selectedItems.length} đơn vị`);
    }
  }, [values]);

  const [resize, SetResize] = useState<any>();

  const [valueTabs, setValueTabs] = useState<string | null>("type");

  const bears = useStepSignStore();
  const [visible, setVisible] = useState(false);

  useHotkeys([
    [
      "Delete",
      () => {
        const filteredData = data.map((document) => ({
          ...document,
          list: document.list.filter(
            (signature) => signature.key !== selectedItemId
          ),
        }));
        setData(filteredData);
      },
    ],
  ]);
  const [stateColor, setStateColor] = useState<string>(listColor[0]);
  useEffect(() => {
    setStateColor(listColor[Number.parseInt(selectedLibrary ?? "0")]);
  }, [selectedLibrary]);

  //new

  const [urlFile, setUrlFile] = useState<string>("");

  /**
   * Hàm chuyển đổi giá trị số thành chuỗi tương ứng
   * @param value Giá trị đầu vào dạng số
   * @returns Chuỗi tương ứng với giá trị số đầu vào
   */

  const _gridType = { base: 6, md: 6, lg: 6, xl: 3 };

  // const [disabledBtn, setDisabledBtn] = useState(false);
  // useEffect(() => {
  //   if (disabledBtn) setDisabledBtn(false);
  // }, [pageCurrent]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  return (
    <>
      <Box pos="relative">
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <div
          style={{
            // float: "inline-end",
            // position: "absolute",
            // bottom: "-20px",
            // right: 0,
            // width: "100%",
            // background: "white",
            marginBottom: "10px",
            zIndex: 999,
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "16px",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <Group>
            <Flex justify={"space-between"} align={"center"}>
              <Badge size="xs" circle mr={"xs"}></Badge> Tổng số bước ký:{" "}
              {formValues.getValues().listStepSign.length}
            </Flex>
            <Flex justify={"space-between"} align={"center"}>
              <Badge size="xs" circle mr={"xs"}></Badge> Tổng số chữ ký:{" "}
              {data.reduce((sum, item) => sum + item.list.length, 0)}
            </Flex>
            <Flex justify={"space-between"} align={"center"}>
              <Badge size="xs" circle mr={"xs"}></Badge> Danh sách bước phê
              duyệt:{" "}
              {
                formValues
                  .getValues()
                  .listStepSign.filter((x) => x.typesigncustomer === 0).length
              }
            </Flex>
          </Group>
          <Group>
            <Button
              size="xs"
              onClick={() => {
                AddStep();
              }}
              leftSection={<IconPlus />}
              variant="outline"
            >
              Thêm bước (Ctrl+D)
            </Button>

            <Button
              variant="outline"
              color="cyan"
              size="xs"
              leftSection={<IconSignature />}
              onClick={async () => {
                if (
                  formValues.validate().hasErrors ||
                  form.validate().hasErrors
                ) {
                  NotificationExtension.Fails(
                    "Vui lòng điền đầy đủ thông tin !"
                  );
                  return;
                }
                if (
                  formValues.isValid() &&
                  formValues.getValues().listStepSign &&
                  formValues.getValues().listStepSign.length > 0
                ) {
                  setDisabledBtn(true);
                  let _entity: TblSampleProcess = form.getValues();
                  const updatedListStepSign = formValues
                    .getValues()
                    .listStepSign.map((item, idx) => ({
                      ...item,
                      numberstep: idx + 1, // Cập nhật numberstep theo thứ tự sắp xếp
                    }));
                  _entity.stepupsignjson = JSON.stringify(updatedListStepSign);

                  _entity.totalstep =
                    formValues.getValues().listStepSign.length;
                  const _checkDep = values.filter((x) => x.selected == true);
                  if (_checkDep && _checkDep.length > 0) {
                    _entity.departmentId = _checkDep
                      .map((x) => x.value)
                      .join(",");
                  }
                  const url = "/api/v1/SampleProcess/create";
                  await DelayTime(500);
                  const result = await repositorySign.post<
                    MessageResponse<boolean>
                  >(url, _entity);
                  if (result && result.httpStatusCode === 200) {
                    if (result.success) {
                      NotificationExtension.Success("Thành công !");
                      setTimeout(() => {
                        navigate("/process-defs/flow-model");
                      }, 2000);
                    } else
                      NotificationExtension.Fails(
                        result.message.length > 0
                          ? result.message
                          : "Thất bại !"
                      );
                    //   setDisabledBtn(false);
                  }
                } else NotificationExtension.Fails("Dữ liệu không đúng !");
                setDisabledBtn(false);
              }}
            >
              Lưu
            </Button>

            <Button
              variant="outline"
              color="red"
              size="xs"
              leftSection={<IconX />}
              onClick={() => navigate("/process-defs/flow-model")}
            >
              Đóng
            </Button>
          </Group>
        </div>
        <div
          style={{
            position: "relative",
            height: "calc(100vh - 150px)",
          }}
        >
          <Grid>
            <Grid.Col span={{ base: 12 }}>
              {" "}
              {Controls()}
              <Grid.Col span={{ base: 12 }}>
                <DragDropContext
                  onDragEnd={({ destination, source }) => {
                    if (destination?.index !== undefined) {
                      formValues.reorderListItem("listStepSign", {
                        from: source.index,
                        to: destination.index,
                      });
                      // const _data = formValues
                      //   .getValues()
                      //   .listStepSign.map((item) => {
                      //     return {
                      //       value: item.key, // Trả về đối tượng với key `value` có giá trị là item.key
                      //     } as ListValue; // Chuyển kiểu dữ liệu về ListValue
                      //   });
                      // setHandlerSelectType(_data);
                      resetHalderSelectType();
                    }
                  }}
                >
                  <Droppable droppableId="dnd-list" direction="vertical">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <ScrollArea h={height}>
                          <Accordion
                            chevronPosition="right"
                            variant="contained"
                            multiple={true}
                          >
                            {items}
                          </Accordion>

                          {/* {items} */}
                        </ScrollArea>

                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid.Col>
            </Grid.Col>
          </Grid>
        </div>
      </Box>
    </>
  );
}

export default FlowStepExampleV2;
